import React, { useState, useRef, useEffect } from 'react';
import { Link , useLocation} from 'react-router-dom';
import axios from 'axios'; //nicht mehr standard, sondern über API bei auth
import { api } from './Api';
import StarRatingSmall from './StarRatingSmall'; // StarRating-Komponente importieren
import Autosuggest from 'react-autosuggest';
import StarRating from './StarRating';
import API_BASE_URL from "./config";
import { compressImage } from './utils/imageCompression';


const MainContent = ({ selectedMenu }) => {
  const [weine, setWeine] = useState([]);
  const [weinForm, setWeinForm] = useState({
    winzer: '',
    name: '',
    rebsorte: '',
    jahr: '',
    preis: '',
    bewertung: 0,
    bild: null,
    anzahlKiste: '',
    land: '',
    region: '',
    bezugsquelle: '',
    farbe: '',
    stil: '',
    praedikat: '',
  });
  const breite= 3;
  const hoehe = 14;
  const [selectedPositions, setSelectedPositions] = useState([]);
  const [belegtePositionen, setBelegtePositionen] = useState([]);
  const [regalPositionen, setRegalPositionen] = useState([]);
  const [kistePositionen, setKistePositionen] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [searchQuery, setSearchQuery] = useState("");
  const [showOnlyGetrunkene, setShowOnlyGetrunkene] = useState(false);
const [showOnlyVorhandene, setShowOnlyVorhandene] = useState(false);
const [winzerList, setWinzerList] = useState([]);
const [weinNames, setWeinNames] = useState([]);
const [rebsorten, setRebsorten] = useState([]);
const [laender, setLaender] = useState([]);
const [regionen, setRegionen] = useState([]);
const [bezugsquellen, setBezugsquellen] = useState([]);
const [winzerSuggestions, setWinzerSuggestions] = useState([]);
const [nameSuggestions, setNameSuggestions] = useState([]);
const [rebsortenSuggestions, setRebsortenSuggestions] = useState([]);
const [laenderSuggestions, setLaenderSuggestions] = useState([]);
const [regionenSuggestions, setRegionenSuggestions] = useState([]);
const [bezugsquellenSuggestions, setBezugsquellenSuggestions] = useState([]);
const [farben, setFarben] = useState([]);
const [stile, setStile] = useState([]);
const [praedikate, setPraedikate] = useState([]);
const [farbenSuggestions, setFarbenSuggestions] = useState([]);
const [stileSuggestions, setStileSuggestions] = useState([]);
const [praedikateSuggestions, setPraedikateSuggestions] = useState([]);
const [neueBewertung, setNeueBewertung] = useState(0);
const [kommentar, setKommentar] = useState("");
const location = useLocation();
// Ref for file input
const fileInputRef = useRef(null);

// useEffect(() => {
//   console.log('Winzer-Liste:', winzerList);
//   console.log('Wein-Namen:', weinNames);
//   console.log('Rebsorten:', rebsorten);
// }, [winzerList, weinNames, rebsorten]);

useEffect(() => {
  if (selectedMenu === 'einkauf' && location.state) {
    const { winzer, name, rebsorte, jahr, preis, land, region, bezugsquelle, farbe, stil, praedikat } = location.state;
    setWeinForm((prevForm) => ({
      ...prevForm,
      winzer: winzer || prevForm.winzer,
      name: name || prevForm.name,
      rebsorte: rebsorte || prevForm.rebsorte,
      jahr: jahr || prevForm.jahr,
      preis: preis || prevForm.preis,
      land: land || prevForm.land,
      region: region || prevForm.region,
      bezugsquelle: bezugsquelle || prevForm.bezugsquelle,
      farbe: farbe || prevForm.farbe,
      stil: stil || prevForm.stil,
      praedikat: praedikat || prevForm.praedikat,
    }));
  }
}, [selectedMenu, location.state]);

const getSuggestions = (value, options) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0
    ? []
    : options.filter(
        (option) => option.toLowerCase().includes(inputValue)
      );
};

  // Funktion zum Abrufen der Regalpositionen und Konfigurationswerte
const fetchRegalData = async () => {
  setLoading(true);
  try {
    // Alle Anfragen gleichzeitig absetzen
    const [regalResponse, kisteResponse] = await Promise.all([
      axios.get(`${API_BASE_URL}/regal/details`),
      axios.get(`${API_BASE_URL}/kiste`)
    ]);

    // Zustände nur aktualisieren, wenn alle Daten erfolgreich geladen wurden
    setRegalPositionen(regalResponse.data);
    setKistePositionen(kisteResponse.data);
  } catch (error) {
    console.error('Fehler beim Laden der Daten:', error);
  } finally {
    setLoading(false); // Ladezustand in jedem Fall zurücksetzen, auch bei Fehlern
  }
};

  // Fetch Weine when 'weine' is selected
  useEffect(() => {
    if (selectedMenu === 'weine') {
      axios
        .get(`${API_BASE_URL}/wein`)
        .then((response) => {
          setWeine(response.data);
        })
        .catch((error) => {
          console.error('Es gab einen Fehler beim Laden der Weine!', error);
        });
    }
  }, [selectedMenu]);

  const sortWeine = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });

    const sortedWeine = [...weine].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1;
      return 0;
    });
    setWeine(sortedWeine);
  };


  // Fetch Config values (Breite and Höhe) and Belegte Positionen when 'einkauf' is selected
  useEffect(() => {
    if (selectedMenu === 'einkauf') {
      //axios.get(`${API_BASE_URL}/auth/regal/belegt`)
      api.get('/auth/regal/belegt')
        .then((response) => {
          setBelegtePositionen(response.data);
        })
        .catch((error) => {
          console.error('Fehler beim Laden der belegten Regalpositionen!', error);
        });
    }
  }, [selectedMenu]);


// Direkt im Funktionskörper (jeder Render)
const isEinkaufValid = (
  // Either at least one Regal position is selected OR "anzahlKiste" is a valid positive number
  ((selectedPositions.length > 0) ||
    (weinForm.anzahlKiste && !isNaN(parseInt(weinForm.anzahlKiste, 10)) && parseInt(weinForm.anzahlKiste, 10) > 0)) &&
  // Required fields must not be empty
  weinForm.winzer.trim() !== "" &&
  weinForm.name.trim() !== "" &&
  weinForm.rebsorte.trim() !== "" &&
  // Jahr must be a number > 1000 and < 3000
  (weinForm.jahr && !isNaN(parseInt(weinForm.jahr, 10)) && parseInt(weinForm.jahr, 10) > 1000 && parseInt(weinForm.jahr, 10) < 3000) &&
  // Preis must be set and numeric
  (weinForm.preis !== "" && !isNaN(parseFloat(weinForm.preis)))
);

const isProbeValid = (
  // Required fields must not be empty
  weinForm.winzer.trim() !== "" &&
  weinForm.name.trim() !== "" &&
  weinForm.rebsorte.trim() !== "" &&
  // Jahr must be a number > 1000 and < 3000
  (weinForm.jahr && !isNaN(parseInt(weinForm.jahr, 10)) && parseInt(weinForm.jahr, 10) > 1000 && parseInt(weinForm.jahr, 10) < 3000) &&
  // Preis must be set and numeric
  (weinForm.preis !== "" && !isNaN(parseFloat(weinForm.preis))) &&
  // For Probe: Bild, Bewertung and Kommentar must be provided
  (weinForm.bild !== null) &&
  (neueBewertung > 0) &&
  (kommentar.trim() !== "")
);

//console.log("Einkauf valid:", isEinkaufValid);
//console.log("Probe valid:", isProbeValid);


  // Fetch Config values (Breite and Höhe) and Belegte Positionen when 'regal' is selected
// Laden der Regalpositionen und Kistenpositionen
  // Verwende einen Effekt, um die Daten abzurufen, wenn das Menü gewechselt wird
  useEffect(() => {
    if (selectedMenu === 'regal') {
      fetchRegalData();
    }
  }, [selectedMenu]);

  useEffect(() => {
    if (selectedMenu === 'einkauf' || selectedMenu === 'probe') {
      // Winzerliste laden
      api.get('/auth/winzer')
        .then((response) => {
          setWinzerList(response.data);
        })
        .catch((error) => {
          console.error('Fehler beim Laden der Winzerliste:', error);
        });

      // Alle Wein-Namen laden (unabhängig vom Winzer)
      api.get('/auth/wein/names')
        .then((response) => {
          setWeinNames(response.data);
        })
        .catch((error) => {
          console.error('Fehler beim Laden der Wein-Namen:', error);
        });

      // Alle Rebsorten laden (unabhängig von Winzer und Name)
      api.get('/auth/wein/rebsorten')
        .then((response) => {
          setRebsorten(response.data);
        })
        .catch((error) => {
          console.error('Fehler beim Laden der Rebsorten:', error);
        });

      // Alle Länder laden
      api.get('/auth/wein/laender')
        .then((response) => {
          setLaender(response.data);
        })
        .catch((error) => {
          console.error('Fehler beim Laden der Länder:', error);
        });

      // Alle Regionen laden
      api.get('/auth/wein/regionen')
        .then((response) => {
          setRegionen(response.data);
        })
        .catch((error) => {
          console.error('Fehler beim Laden der Regionen:', error);
        });

      // Alle Bezugsquellen laden
      api.get('/auth/wein/bezugsquellen')
        .then((response) => {
          setBezugsquellen(response.data);
        })
        .catch((error) => {
          console.error('Fehler beim Laden der Bezugsquellen:', error);
        });

      // Alle Farben laden
      api.get('/auth/wein/farben')
        .then((response) => {
          setFarben(response.data);
        })
        .catch((error) => {
          console.error('Fehler beim Laden der Farben:', error);
        });

      // Alle Stile laden
      api.get('/auth/wein/stile')
        .then((response) => {
          setStile(response.data);
        })
        .catch((error) => {
          console.error('Fehler beim Laden der Stile:', error);
        });

      // Alle Prädikate laden
      api.get('/auth/wein/praedikate')
        .then((response) => {
          setPraedikate(response.data);
        })
        .catch((error) => {
          console.error('Fehler beim Laden der Prädikate:', error);
        });
    }
  }, [selectedMenu]);

 

  // Funktion, um belegte Positionen zu finden
  const getWeinAtPosition = (breite, hoehe) => {
    return regalPositionen.find(
      (pos) => pos.breite === breite && pos.hoehe === hoehe
    );
  };

 // Handle input change for form fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setWeinForm({ ...weinForm, [name]: value });
  };

  // Handle file change for image input
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        // Bild komprimieren vor dem Upload
        const compressedFile = await compressImage(file);
        setWeinForm({ ...weinForm, bild: compressedFile });
      } catch (error) {
        console.error('Fehler bei der Bildkomprimierung:', error);
        // Bei Fehler das Original verwenden
        setWeinForm({ ...weinForm, bild: file });
      }
    }
  };

  // Handle position selection for Regal
  const handlePositionSelect = (breite, hoehe) => {
    const position = { breite, hoehe };
    setSelectedPositions((prev) =>
      prev.some((p) => p.breite === breite && p.hoehe === hoehe)
        ? prev.filter((p) => !(p.breite === breite && p.hoehe === hoehe))
        : [...prev, position]
    );
  };

  const isPositionBelegt = (breite, hoehe) => {
    return belegtePositionen.some(
      (pos) => pos.breite === breite && pos.hoehe === hoehe
    );
  };

  // Handle form submission for adding a new Wein
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
   formData.append('winzer', weinForm.winzer);
    formData.append('name', weinForm.name);
    formData.append('rebsorte', weinForm.rebsorte);
    formData.append('jahr', weinForm.jahr);
    formData.append('preis', weinForm.preis);
    formData.append('bewertung', weinForm.bewertung);
    formData.append('bild', weinForm.bild);
    formData.append('land', weinForm.land || '');
    formData.append('region', weinForm.region || '');
    formData.append('bezugsquelle', weinForm.bezugsquelle || '');
    formData.append('farbe', weinForm.farbe || '');
    formData.append('stil', weinForm.stil || '');
    formData.append('praedikat', weinForm.praedikat || '');
    //formData.append('breite', selectedPosition.breite);
    //formData.append('hoehe', selectedPosition.hoehe);

    // Gekaufte Menge = Flaschen in extra Kiste + gewählte Regalpositionen.
    // Mind. 1, falls (noch) keine Platzierung gewählt wurde.
    const kistenAnzahl = parseInt(weinForm.anzahlKiste, 10) || 0;
    const gekaufteAnzahl = Math.max(1, kistenAnzahl + selectedPositions.length);
    formData.append('anzahl', gekaufteAnzahl);

    // Wein speichern
    //axios
    //  .post(`${API_BASE_URL}/auth/wein/upload`, formData, {
    //    headers: {
    //      'Content-Type': 'multipart/form-data',
    //    },
    api.post('/auth/wein/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((response) => {
        const weinID = response.data.wein.ID; // Die Wein-ID nach dem Speichern erhalten

        console.log('Wein erfolgreich hinzugefügt:', response.data);
    
        // Wenn der Benutzer Flaschen in eine Kiste speichert
        if (weinForm.anzahlKiste && weinForm.anzahlKiste > 0) {
        //  axios.post(`${API_BASE_URL}/auth/kiste`, {
        //    anzahl: parseInt(weinForm.anzahlKiste, 10), // Stelle sicher, dass `anzahlKiste` als int gesendet wird
        api.post('/auth/kiste', {
          anzahl: parseInt(weinForm.anzahlKiste, 10),
            wein_id: weinID,
          })
          .then(() => {
            console.log('Kiste erfolgreich hinzugefügt');
          })
          .catch((error) => {
            console.error('Fehler beim Hinzufügen der Kiste:', error);
          });
        }
    
     
          // Speichern der ausgewählten Regalpositionen
        const saveRegalRequests = selectedPositions.map((position) => {
         // return axios.post(`${API_BASE_URL}/auth/regal`, {
          return api.post('/auth/regal', {
            breite: position.breite,
            hoehe: position.hoehe,
            wein_id: weinID,
          });
        });

        // Nachdem alle Regalpositionen gespeichert wurden, aktualisiere die belegten Positionen
        Promise.all(saveRegalRequests)
          .then(() => {
            console.log('Alle Regalpositionen erfolgreich hinzugefügt');

            // Abrufen der belegten Positionen erneut
            //axios.get(`${API_BASE_URL}/auth/regal/belegt`)
            api.get('/auth/regal/belegt')
              .then((response) => {
                setBelegtePositionen(response.data);
              })
              .catch((error) => {
                console.error('Fehler beim Laden der belegten Regalpositionen:', error);
              });
          })
          .catch((error) => {
            console.error('Fehler beim Hinzufügen der Regalpositionen:', error);
          });



        // Formular zurücksetzen
        setWeinForm({
          winzer: '',
          name: '',
          rebsorte: '',
          jahr: '',
          preis: '',
          bewertung: 0,
          bild: null,
          anzahlKiste: '',
          land: '',
          region: '',
          bezugsquelle: '',
          farbe: '',
          stil: '',
          praedikat: '',
        });
        setSelectedPositions([]);
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
      })
      .catch((error) => {
        console.error('Fehler beim Hinzufügen des Weins und Bilds:', error);
      });
    };

    const handleSubmitProbe = (e) => {
      e.preventDefault();

      const formData = new FormData();
     formData.append('winzer', weinForm.winzer);
      formData.append('name', weinForm.name);
      formData.append('rebsorte', weinForm.rebsorte);
      formData.append('jahr', weinForm.jahr);
      formData.append('preis', weinForm.preis);
      formData.append('bewertung', weinForm.bewertung);
      formData.append('bild', weinForm.bild);
      formData.append('land', weinForm.land || '');
      formData.append('region', weinForm.region || '');
      formData.append('bezugsquelle', weinForm.bezugsquelle || '');
      formData.append('farbe', weinForm.farbe || '');
      formData.append('stil', weinForm.stil || '');
      formData.append('praedikat', weinForm.praedikat || '');
      //formData.append('breite', selectedPosition.breite);
      //formData.append('hoehe', selectedPosition.hoehe);

      // Wein speichern
      // axios
      //  .post(`${API_BASE_URL}/auth/wein/upload`, formData, {
        api.post('/auth/wein/probe', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const weinID = response.data.wein.ID; // Die Wein-ID nach dem Speichern erhalten
  
          console.log('Wein erfolgreich hinzugefügt:', response.data);
          api.post(`/auth/wein/${weinID}/weinprobe`, {
          //axios.post(`${API_BASE_URL}/auth/wein/${weinID}/bewerten`, {
            bewertung: neueBewertung,
            kommentar: kommentar,
          })
          .then((response) => {
            console.log('Bewertung erfolgreich hinzugefügt!');
            setKommentar("");
            setNeueBewertung(0);
            // Bewertungen aktualisieren
            return axios.get(`${API_BASE_URL}/wein/${weinID}`);
           //return api.get(`/auth/wein/${weinID}`);
          })
          .catch((error) => {
            console.error('Fehler beim Hinzufügen der Bewertung!', error);
          });
          
  
  
  
          // Formular zurücksetzen
          setWeinForm({
            winzer: '',
            name: '',
            rebsorte: '',
            jahr: '',
            preis: '',
            bewertung: 0,
            bild: null,
            anzahlKiste: '',
            land: '',
            region: '',
            bezugsquelle: '',
            farbe: '',
            stil: '',
            praedikat: '',
          });
          setSelectedPositions([]);
          if (fileInputRef.current) {
            fileInputRef.current.value = null;
          }
        })
        .catch((error) => {
          console.error('Fehler beim Hinzufügen des Weins und Bilds:', error);
        });
      };

/*     const filteredWeine = weine.filter(
      (wein) =>
        (wein.winzer.toLowerCase().includes(searchQuery.toLowerCase()) ||
         wein.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
         wein.rebsorte.toLowerCase().includes(searchQuery.toLowerCase())) &&
        (!showOnlyGetrunkene || wein.anzahl_getrunken > 0) &&
        (!showOnlyVorhandene || wein.lagerbestand > 0)
    ); */
    
    const filteredWeine = weine.filter((wein) => {
      const q = searchQuery.toLowerCase();
      const matchesSearch =
        wein.winzer.toLowerCase().includes(q) ||
        wein.name.toLowerCase().includes(q) ||
        wein.rebsorte.toLowerCase().includes(q) ||
        (wein.land || '').toLowerCase().includes(q) ||
        (wein.farbe || '').toLowerCase().includes(q) ||
        (wein.stil || '').toLowerCase().includes(q) ||
        (wein.praedikat || '').toLowerCase().includes(q);
      const matchesGetrunken = !showOnlyGetrunkene || wein.anzahl_getrunken > 0;
      const matchesVorhanden = !showOnlyVorhandene || wein.lagerbestand > 0;
      return matchesSearch && matchesGetrunken && matchesVorhanden;
    });    





  return (
    <div className="p-4" style={{ flex: 1 }}>
           {selectedMenu === 'regal' && (
  <div>
          {loading ? (
        <p>Daten werden geladen...</p>
      ) : (
 <div className="regal-container-bild">
  {[...Array(hoehe)].map((_, rowIndex) => (
    <div key={rowIndex} className="regal-row">
      {[...Array(breite)].map((_, colIndex) => {
        const weinPosition = getWeinAtPosition(colIndex, rowIndex);
        if (!weinPosition || !weinPosition.Wein) {
          // Gebe eine leere Zelle zurück, wenn weinPosition oder weinPosition.Wein nicht definiert ist
          return (
            <div key={colIndex} className="regal-cell-bild">
              <div className="empty-cell" />
            </div>
          );
        }

        return (
          <div key={colIndex} className="regal-cell-bild">
            <div className="wein-details">
              {weinPosition.Wein.bild_pfad_thumb || weinPosition.Wein.bild_pfad ? (
                <img
                  src={`${process.env.REACT_APP_API_URL.replace('/api', '')}/${weinPosition.Wein.bild_pfad_thumb || weinPosition.Wein.bild_pfad}`}
                  alt={weinPosition.Wein.name}
                  className="wein-bild"
                />
              ) : (
                <p>Kein Bild verfügbar</p>
              )}
              <div className="wein-info">
                <strong>{weinPosition.Wein.winzer}</strong>
                <p>
                  <Link to={`/wein/${weinPosition.Wein.ID}`}>{weinPosition.Wein.name}</Link>
                </p>
                <p>€{weinPosition.Wein.preis.toFixed(2)}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  ))}
</div>
      )}
  <div className="kiste-container">
  <p></p>
  <h3>Kiste</h3>
  <div className="kiste-regal">
  {loading ? (
              <p>Kistendaten werden geladen...</p>
            ) : (
              kistePositionen.map((kiste, index) => {
                if (!kiste || !kiste.Wein) {
          return (
            <div key={index} className="kiste-cell">
              <p>Keine Daten verfügbar</p>
            </div>
          );
        }

        const { anzahl, Wein } = kiste;

        return (
          <div key={index} className="kiste-cell">
            {/* Erste Spalte: Anzahl */}
            <div className="kiste-spalte-anzahl">
              <strong>{anzahl}x</strong>
            </div>
        
            {/* Zweite Spalte: Bild */}
            <div className="kiste-spalte-bild">
              {Wein.bild_pfad_thumb || Wein.bild_pfad ? (
                <img
                  src={`${process.env.REACT_APP_API_URL.replace('/api', '')}/${Wein.bild_pfad_thumb || Wein.bild_pfad}`}
                  alt={Wein.name}
                  className="kiste-wein-bild"
                />
              ) : (
                <p>Kein Bild verfügbar</p>
              )}
            </div>
        
            {/* Dritte Spalte: Informationen */}
            <div className="kiste-spalte-info">
              <strong>{Wein.winzer}</strong>
              <span><Link to={`/wein/${Wein.ID}`}>{Wein.name}</Link></span>
              <span>€{Wein.preis.toFixed(2)}</span>
            </div>
          </div>
        );
        
        
      })
    )}
  </div>
</div>









</div>
      )}

      {selectedMenu === 'weine' && (
        <div>
          <h2>Weine</h2>
          <input
      type="text"
      placeholder="Wein suchen..."
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      className="form-control mb-3"
    />

<div className="filters mb-3">
  <input
    type="checkbox"
    id="filter-getrunkene"
    checked={showOnlyGetrunkene}
    onChange={(e) => setShowOnlyGetrunkene(e.target.checked)}
  />
  <label htmlFor="filter-getrunkene" className="ms-2 me-4">
    Nur getrunkene Weine
  </label>
  
  <input
    type="checkbox"
    id="filter-vorhandene"
    checked={showOnlyVorhandene}
    onChange={(e) => setShowOnlyVorhandene(e.target.checked)}
  />
  <label htmlFor="filter-vorhandene" className="ms-2">
    Nur vorhandene Weine
  </label>
</div>


          <table className="table table-striped">
            <thead>
            <tr>
                <th>
                  Lag.
                  <button onClick={() => sortWeine('lagerbestand')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}
                    >⇅</button>
                </th>
                <th>
                  Winzer
                  <button onClick={() => sortWeine('winzer')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}
                    >⇅</button>
                </th>
                <th>
                  Name
                  <button onClick={() => sortWeine('name')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>⇅</button>
                </th>
                <th>
                  Rebsorte
                  <button onClick={() => sortWeine('rebsorte')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>⇅</button>
                </th>
                <th>
                  Farbe
                  <button onClick={() => sortWeine('farbe')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>⇅</button>
                </th>
                <th>
                  Stil
                  <button onClick={() => sortWeine('stil')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>⇅</button>
                </th>
                <th>
                  Präd.
                  <button onClick={() => sortWeine('praedikat')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>⇅</button>
                </th>
                <th>
                  Jahr
                  <button onClick={() => sortWeine('jahr')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>⇅</button>
                </th>
                <th>
                  Preis
                  <button onClick={() => sortWeine('preis')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>⇅</button>
                </th>
                <th>
                  Land
                  <button onClick={() => sortWeine('land')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>⇅</button>
                </th>
                <th>Bewertung
                <button onClick={() => sortWeine('bewertung')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>⇅</button>
                </th>
                <th>Getr.
                <button onClick={() => sortWeine('anzahl_getrunken')}
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer' }}>⇅</button>
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredWeine.map((wein) => (
                <tr key={wein.ID}>
                  <td>{wein.lagerbestand}</td>
                  <td>{wein.winzer}</td>
                  <td>
                    <Link to={`/wein/${wein.ID}`}>{wein.name}</Link>
                  </td>
                  <td>{wein.rebsorte}</td>
                  <td>{wein.farbe}</td>
                  <td>{wein.stil}</td>
                  <td>{wein.praedikat}</td>
                  <td>{wein.jahr}</td>
                  <td>{wein.preis.toFixed(2)}</td>
                  <td>{wein.land}</td>
                  <td><StarRatingSmall rating={wein.bewertung} setRating={() => {}} readonly={true} /></td>
                  <td>{wein.anzahl_getrunken}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedMenu === 'einkauf' && (
        <div>
          <h2>Einkauf</h2>

          {/* Regal Position auswählen */}
          <div className="mb-4">
          <label className="form-label">Regal Position auswählen</label>
             <div className="regal-container">
              {[...Array(hoehe)].map((_, rowIndex) => (
                <div key={rowIndex} className="regal-row">
                  {[...Array(breite)].map((_, colIndex) => (
                    <div key={colIndex} className="regal-cell">
                      <input
                        type="checkbox"
                        name="regalPosition"
                        className="regal-checkbox"
                        disabled={isPositionBelegt(colIndex, rowIndex)}
                        checked={selectedPositions.some(
                          (pos) => pos.breite === colIndex && pos.hoehe === rowIndex
                        )}
                        onChange={() => handlePositionSelect(colIndex, rowIndex)}
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className="mb-4">
  <label className="form-label">Anzahl Flaschen in extra Kiste (wenn nicht im Regal)</label>
  <input
    type="number"
    className="form-control"
    name="anzahlKiste"
    min="1"
    max="48"
    value={weinForm.anzahlKiste || ""}
    onChange={(e) => setWeinForm({ ...weinForm, anzahlKiste: e.target.value })}
  />
</div>
<h3>Wein</h3>

          {/* Wein hinzufügen Formular */}
          <form onSubmit={handleSubmit}>
            {/* Winzer Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Winzer</label>
              <Autosuggest
                suggestions={winzerSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setWinzerSuggestions(getSuggestions(value, winzerList));
                }}
                onSuggestionsClearRequested={() => {
                  setWinzerSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'winzer',
                  value: weinForm.winzer,
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'winzer', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Name Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Name</label>
              <Autosuggest
                suggestions={nameSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setNameSuggestions(getSuggestions(value, weinNames));
                }}
                onSuggestionsClearRequested={() => {
                  setNameSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'name',
                  value: weinForm.name,
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'name', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Rebsorte Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Rebsorte</label>
              <Autosuggest
                suggestions={rebsortenSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setRebsortenSuggestions(getSuggestions(value, rebsorten));
                }}
                onSuggestionsClearRequested={() => {
                  setRebsortenSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'rebsorte',
                  value: weinForm.rebsorte,
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'rebsorte', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Jahr</label>
              <input
                type="number"
                className="form-control"
                name="jahr"
                value={weinForm.jahr}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Preis (€)</label>
              <input
                type="number"
                step="0.01"
                className="form-control"
                name="preis"
                value={weinForm.preis}
                onChange={handleInputChange}
              />
            </div>

            {/* Land Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Land</label>
              <Autosuggest
                suggestions={laenderSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setLaenderSuggestions(getSuggestions(value, laender));
                }}
                onSuggestionsClearRequested={() => {
                  setLaenderSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'land',
                  value: weinForm.land || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'land', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Region Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Region</label>
              <Autosuggest
                suggestions={regionenSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setRegionenSuggestions(getSuggestions(value, regionen));
                }}
                onSuggestionsClearRequested={() => {
                  setRegionenSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'region',
                  value: weinForm.region || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'region', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Bezugsquelle Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Bezugsquelle</label>
              <Autosuggest
                suggestions={bezugsquellenSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setBezugsquellenSuggestions(getSuggestions(value, bezugsquellen));
                }}
                onSuggestionsClearRequested={() => {
                  setBezugsquellenSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'bezugsquelle',
                  value: weinForm.bezugsquelle || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'bezugsquelle', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Farbe Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Farbe</label>
              <Autosuggest
                suggestions={farbenSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setFarbenSuggestions(getSuggestions(value, farben));
                }}
                onSuggestionsClearRequested={() => {
                  setFarbenSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'farbe',
                  value: weinForm.farbe || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'farbe', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Stil Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Stil</label>
              <Autosuggest
                suggestions={stileSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setStileSuggestions(getSuggestions(value, stile));
                }}
                onSuggestionsClearRequested={() => {
                  setStileSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'stil',
                  value: weinForm.stil || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'stil', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Prädikat Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Prädikat</label>
              <Autosuggest
                suggestions={praedikateSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setPraedikateSuggestions(getSuggestions(value, praedikate));
                }}
                onSuggestionsClearRequested={() => {
                  setPraedikateSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'praedikat',
                  value: weinForm.praedikat || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'praedikat', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Bild</label>
              <input
                type="file"
                className="form-control"
                name="bild"
                ref={fileInputRef}
                onChange={handleFileChange}
              />
            </div>
            <button type="submit" className="btn btn-primary"  disabled={!isEinkaufValid}>
              Hinzufügen
            </button>
          </form>
        </div>
      )}
{selectedMenu === 'probe' && (
        <div>
          <h2>Weinprobe</h2>

<h3>Wein</h3>

          {/* Wein hinzufügen Formular */}
          <form onSubmit={handleSubmitProbe}>
            {/* Winzer Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Winzer</label>
              <Autosuggest
                suggestions={winzerSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setWinzerSuggestions(getSuggestions(value, winzerList));
                }}
                onSuggestionsClearRequested={() => {
                  setWinzerSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'winzer',
                  value: weinForm.winzer,
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'winzer', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Name Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Name</label>
              <Autosuggest
                suggestions={nameSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setNameSuggestions(getSuggestions(value, weinNames));
                }}
                onSuggestionsClearRequested={() => {
                  setNameSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'name',
                  value: weinForm.name,
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'name', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Rebsorte Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Rebsorte</label>
              <Autosuggest
                suggestions={rebsortenSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setRebsortenSuggestions(getSuggestions(value, rebsorten));
                }}
                onSuggestionsClearRequested={() => {
                  setRebsortenSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'rebsorte',
                  value: weinForm.rebsorte,
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'rebsorte', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Jahr</label>
              <input
                type="number"
                className="form-control"
                name="jahr"
                value={weinForm.jahr}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Preis (€)</label>
              <input
                type="number"
                step="0.01"
                className="form-control"
                name="preis"
                value={weinForm.preis}
                onChange={handleInputChange}
              />
            </div>

            {/* Land Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Land</label>
              <Autosuggest
                suggestions={laenderSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setLaenderSuggestions(getSuggestions(value, laender));
                }}
                onSuggestionsClearRequested={() => {
                  setLaenderSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'land',
                  value: weinForm.land || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'land', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Region Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Region</label>
              <Autosuggest
                suggestions={regionenSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setRegionenSuggestions(getSuggestions(value, regionen));
                }}
                onSuggestionsClearRequested={() => {
                  setRegionenSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'region',
                  value: weinForm.region || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'region', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Bezugsquelle Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Bezugsquelle</label>
              <Autosuggest
                suggestions={bezugsquellenSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setBezugsquellenSuggestions(getSuggestions(value, bezugsquellen));
                }}
                onSuggestionsClearRequested={() => {
                  setBezugsquellenSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'bezugsquelle',
                  value: weinForm.bezugsquelle || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'bezugsquelle', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Farbe Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Farbe</label>
              <Autosuggest
                suggestions={farbenSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setFarbenSuggestions(getSuggestions(value, farben));
                }}
                onSuggestionsClearRequested={() => {
                  setFarbenSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'farbe',
                  value: weinForm.farbe || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'farbe', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Stil Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Stil</label>
              <Autosuggest
                suggestions={stileSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setStileSuggestions(getSuggestions(value, stile));
                }}
                onSuggestionsClearRequested={() => {
                  setStileSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'stil',
                  value: weinForm.stil || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'stil', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            {/* Prädikat Autocomplete */}
            <div className="mb-3">
              <label className="form-label">Prädikat</label>
              <Autosuggest
                suggestions={praedikateSuggestions}
                onSuggestionsFetchRequested={({ value }) => {
                  setPraedikateSuggestions(getSuggestions(value, praedikate));
                }}
                onSuggestionsClearRequested={() => {
                  setPraedikateSuggestions([]);
                }}
                getSuggestionValue={(suggestion) => suggestion}
                renderSuggestion={(suggestion) => <div>{suggestion}</div>}
                inputProps={{
                  name: 'praedikat',
                  value: weinForm.praedikat || '',
                  onChange: (e, { newValue }) => {
                    handleInputChange({
                      target: { name: 'praedikat', value: newValue },
                    });
                  },
                  className: 'form-control',
                  placeholder: '',
                }}
                theme={{
                  container: 'autosuggest-container',
                  suggestionsContainer: 'autosuggest-suggestions-container',
                  suggestion: 'autosuggest-suggestion',
                  suggestionHighlighted: 'autosuggest-suggestion--highlighted',
                }}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Bild</label>
              <input
                type="file"
                className="form-control"
                name="bild"
                ref={fileInputRef}
                onChange={handleFileChange}
              />
            </div>
            <h3>Bewertung</h3>
        <StarRating rating={neueBewertung} setRating={setNeueBewertung} />
        <textarea
          className="form-control"
          rows="3"
          value={kommentar}
          onChange={(e) => setKommentar(e.target.value)}
          placeholder="Kommentar eingeben..."
          style={{ marginBottom: '10px' }}
        />

            <button type="submit" className="btn btn-primary" disabled={!isProbeValid}>
              Hinzufügen
            </button>
          </form>
        </div>
      )}

    </div>
  );
};

export default MainContent;

